export default __webpack_public_path__ + "static/media/employeeCorrection.ba27c68e.svg";